module.exports = __webpack_public_path__ + "static/img/SAMURAISHODOWN.eccf018.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vidio/SAMURAISHODOWN.jpg
// module id = FSoU
// module chunks = 0